import styled from 'styled-components';

interface IBottomButton {
  isDesk: boolean;
}

const ButtonDesk = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: none;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  color: ${({ theme }) => theme.primaryColor};
`;

const Title = styled.h3<IBottomButton>`
  font-size: ${({ isDesk }) => (isDesk ? '16px' : '14px')};
  font-weight: 500;
  text-align: center;
  color: #404040;
  text-transform: none;
  margin: 15px 0;
`;

const Wrapper = styled.div<IBottomButton>`
  display: ${({ isDesk }) => (isDesk ? 'flex' : '')};
  gap: ${({ isDesk }) => (isDesk ? '18px' : '')};
  margin-bottom: ${({ isDesk }) => (isDesk ? '8px' : '25px')};
`;

const Hr = styled.hr<IBottomButton>`
  position: relative;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #e8e8e8;
  display: ${({ isDesk }) => (isDesk ? 'none' : '')};
`;

export { Title, Wrapper, Hr, ButtonDesk };
